<template>
  <div>
    <div class="search-content">
      <el-menu :default-active="activeIndex"  v-if="ismanage" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="1">注册审核</el-menu-item>
        <el-menu-item index="2">销售情况</el-menu-item>
      </el-menu>
      <el-col :span="24" class="toobar">
        <el-col :span="10">
          <el-select v-model="searchtenant" placeholder="请选择" v-if="ismanage" clearable
                     style="width: 150px">
            <el-option
              v-for="item in tenantList"
              :key="item.tenantid"
              :label="item.tenantname"
              :value="item.tenantid">
            </el-option>
          </el-select>
          <el-input style="width:150px;"
                    placeholder="请输入医院名称查询"
                    prefix-icon="el-icon-search"
                    v-model="searchdata">
          </el-input>
          <el-date-picker ref="datepicker" style="width: 224px" v-if="activeIndex=='2'"
                          v-model="searchdatevalue" :clearable="false"
                          type="daterange" :value-format="'yyyy-MM-dd'"
                          align="left" :unlink-panels="false"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期" @change="checkDateSepar"
                          :picker-options="pickerOptions2">
          </el-date-picker>
          <el-select v-model="casestatus" placeholder="状态" clearable v-if="activeIndex=='1'"
                     style="width: 150px">
            <el-option label="待授权" value="0"></el-option>
            <el-option label="洽谈中" value="1"></el-option>
            <el-option label="签约中" value="9"></el-option>
            <el-option label="已签约" value="10"></el-option>
          </el-select>
          <el-checkbox v-model="form.validitydate" v-if="activeIndex=='1'">已过期</el-checkbox>
        </el-col>
          <el-col :span="8">
          <v-distpicker :province="form.province" @province="onChangeProvince" :city="form.city" @city="onChangeCity" :area="form.county" @area="onChangeArea" size="mini"></v-distpicker>
          </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="bindGrid" >搜索</el-button>
          <el-button type="warning" @click="excelPort">导出</el-button>
          <el-button type="warning" icon="el-icon-edit" @click="addStore" v-if="!independentserial&&activeIndex=='1'">增加医院</el-button>
        </el-col>
        <ExternaldeptEdit ref="DataContactEditOther" @AfterSave="AfterDeptCreate"></ExternaldeptEdit>
        <hospitalAdd ref="hospitalAdd1" :managetenantid="managetenantid" :ismanage="ismanage" @bindGrid="bindGrid"></hospitalAdd>
      </el-col>
    </div>
      <el-table :data="tableAudit.filter(o=>o.hasvalue)" size="mini" stripe border :row-class-name="tableRowClassName"
                show-summary="activeIndex=='2'" :summary-method="getSummaries"
                :height="thistableHeight()">
        <el-table-column width="60" label="序号" align="center" fixed>
          <template slot-scope="scope">
            {{1+scope.$index}}
          </template>
        </el-table-column>
        <el-table-column prop="tenantname" label="服务商" align="left" header-align="center" :show-overflow-tooltip="true" width="260"></el-table-column>
        <el-table-column prop="deptname"  label="名称" align="left" header-align="center" :show-overflow-tooltip="true" width="260"></el-table-column>
        <template  v-if="activeIndex=='2'">
          <el-table-column
            prop="ordernumsummary"
            label="销售数量" sortable
            align="right"
            header-align="center"
            width="100">
            <template slot-scope="scope">
              {{scope.row.ordernumsummary|numeric(0)}}
            </template>
          </el-table-column>
          <el-table-column
            label="销售单价"
            align="right"
            header-align="center"
            width="100">
            <template slot-scope="scope">
              {{scope.row.orderpricesummary|numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="ordermoneysummary"
            label="销售金额" sortable
            align="right"
            header-align="center"
            width="140">
            <template slot-scope="scope">
              {{scope.row.ordermoneysummary|numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="fahuonumsummary"
            label="发货数量" sortable
            align="right"
            header-align="center"
            width="100">
            <template slot-scope="scope">
              {{scope.row.fahuonumsummary|numeric(0)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="fahuomoneysummary"
            label="发货金额" sortable
            align="right"
            header-align="center"
            width="140">
            <template slot-scope="scope">
              {{scope.row.fahuomoneysummary|numeric(2)}}
            </template>
          </el-table-column>
        </template>
        <template  v-if="activeIndex=='1'">
        <el-table-column label="区域" align="left" header-align="center" :show-overflow-tooltip="true" width="150">
          <template slot-scope="scope">
          {{scope.row.province}} {{scope.row.city}} {{scope.row.county}}
          </template>
        </el-table-column>
        <el-table-column prop="adddate" label="提交日期" header-align="center" align="left" width="150"></el-table-column>
        <el-table-column prop="uname" label="提交人" width="100" header-align="center" align="left"></el-table-column>
        <el-table-column prop="descri" label="备注" align="left" header-align="center" :show-overflow-tooltip="true" width="150"></el-table-column>
        <el-table-column prop="auditdate" label="授权日期" header-align="center" align="left" width="150"></el-table-column>
        <el-table-column prop="bond" label="保证金" header-align="center" align="left" width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="validitydate" label="有效期" header-align="center" align="left" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.casestatus<9">{{scope.row.validitydate?scope.row.validitydate.replace("00:00:00",""):""}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contractdate" label="签约日期" header-align="center" align="left" width="150"></el-table-column>
        <el-table-column width="100" label="状态" align="center" fixed="right">
          <template slot-scope="scope">
            <el-tag :type="'danger'" v-if="scope.row.casestatus==0">待授权</el-tag>
            <el-tag :type="'success'" v-if="scope.row.casestatus==1">洽谈中</el-tag>
            <el-tag :type="'primary'" v-if="scope.row.casestatus>=9">已签约</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="left" width="200" fixed="right" v-if="!independentserial">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row,$event)">操作</el-button>
            <el-button size="mini" type="danger" @click="distributorHandleEdit(scope.row)" v-if="scope.row.tenantid==mytenantid&&scope.row.casestatus==9">补客户信息</el-button>
            <el-button size="mini" type="primary" @click="distributorHandleView(scope.row)" v-if="scope.row.tenantid==mytenantid&&scope.row.casestatus==10">详情</el-button>
            <el-button size="mini" type="info" @click="handleDelete(scope.$index, scope.row)" v-if="ismanage&&scope.row.casestatus<9">删除</el-button>
          </template>
        </el-table-column>
        </template>
      </el-table>
    <div class="foot" v-if="activeIndex=='1'">
      <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
    </div>
  </div>
</template>
<script>
  import ExternaldeptEdit from '../../set/externaldept/ExternaldeptEdit';
  import hospitalAdd from './hospitalAdd';
  import {attUUID} from '@/api/attachment';
  import {savehospital,listdeptpre,listhospital,removehospital,updatehospital,detailhospital,subhospital} from '@/api/set/externaldept';
  import {pickerShortCuts} from '@/plugin/ordercommon';

  export default {
    name: 'auditList',
    data() {
      return {
        dialogVisible: false,
        managetenantid: '',
        activeIndex:'1',
        searchdatevalue:'',
        oldsearchdatevalue:'',
        independentserial:'',
        editrow:{},
        ismanage: false,
        linkman: '',
        linkmantel: '',
        tenantList: [],
        searchtenant: '',
        casestatus:'',
        mytenantid:'',
        showButtonColum: true,
        EditData: [],
        msg: '',
        dialogFormVisible: false,
        searchdata: "",
        loading: true,
        pickerOptions2: {
          shortcuts: []
        },
        pagination: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        tableAudit: [],
        servedserial: '',
        settingmenthod: '',
        servedname: '',
        serveuguid: '',//业务员ID
        serveuname: '',//业务员名称
        form:{
          province:'',city:'',county:'',validitydate:false
        },
      }
    },
    methods: {
      checkDateSepar(value) {
        var startDate = new Date(value[0]);
        var endDate = new Date(value[1]);
        var preDate = endDate.getMonth() >= 12 ? new Date(endDate.getFullYear() + '-' + (endDate.getMonth() + 1 - 12) + '-' + endDate.getDate())
          : new Date((endDate.getFullYear() - 1) + '-' + (12 + endDate.getMonth() + 1 - 12) + '-' + endDate.getDate());
        var errerMSG = "只能查询一年内的数据！";
        // if (!this.$checkRight("财务") && this.userInfoModel.tenantid == 'e5682784-dbb7-4eba-939f-4c265092db1d') {
        //   preDate = new Date(endDate.getTime() - 31 * 24 * 60 * 60 * 1000);
        //   errerMSG = "只能查询一个月范围内的数据！";
        // }
        if (startDate <= preDate) {
          this.$message({
            message: errerMSG,
            type: 'error'
          })
          this.searchdatevalue = this.oldsearchdatevalue;//还原
        } else {
          this.oldsearchdatevalue = this.searchdatevalue;
        }
      },
      onChangeProvince(data) {
        if (data.value == '省') data.value = '';
        this.form.province = data.value;
        this.form.city = ''
        this.form.county = ''
      }, onChangeCity(data) {
        if (data.value == '市') data.value = '';
        this.form.city = data.value;
        this.form.county = ''
      }, onChangeArea(data) {
        if (data.value == '区' || data.value == '县') data.value = '';
        this.form.county = data.value;
      },
      tableRowClassName({row, rowIndex}) {
        if (row.validitydate&&row.casestatus<9&&new Date(row.validitydate)<new Date()) {
          return 'warning-row';
        }
        return '';
      },
      addStore() {
        this.$refs.hospitalAdd1.show();
      },
      getSetname(setname) {
        if (!setname) return '';
        setname = setname.replace('全额现结', '现金');
        if (setname.startsWith(',')) {
          setname = setname.substr(1);
        }
        if (setname == '现金,月结') {
          setname = '月结,现金'
        }
        return setname;
      },
      //选择业务员后
      changeServer(guids, names, arr) {
        this.serveuguid = guids;
        this.serveuname = names;
      },
      thistableHeight() {
        return this.tableHeight(126);
      },
      distributorHandleEdit(row) {
        this.editrow=row;
        var address=JSON.stringify([{"address":row.deliveryaddress,"province":row.province,"city":row.city,"county":row.county,"defalut":"1","mobile":"","uname":"","unitguid":attUUID()}]);
        var yecontent = {
          "unitguid": '',
          "isperson": 0,
          "deptname": row.deptname,
          "linkman": "",
          "linkmantel": "",
          "unitgroup": "1",
          "pricelevel": "",
          "settingmenthod": "200",
          "servedname": "",
          "serveuguid": "",
          "servedserial": "",
          "serveuname": "",
          "iddirectsend": 0,
          "freightfree": 0,
          "deliveryaddress": address,
          "ticket": "",
          "contactor": "[]",
          "attguid": row.attguid,
          "usesso": "",
          "ssocode": "",
          "province": row.province,
          "city": row.city,
          "county": row.county,
          "audittenantid":this.managetenantid
        }
        this.$refs.DataContactEditOther.ShowAudit(yecontent, true);
      },
      excelPort() {
        var data = this.tableAudit;
        var header1 = [];
        var column1 = [];
        var name = '';
        if (this.activeIndex == '2') {
          header1 = ["服务商", "名称", "销售数量", "销售单价", "销售金额", "发货数量", "发货金额"]
          column1 = ["tenantname", "deptname", "ordernumsummary", "orderpricesummary", "ordermoneysummary", "fahuonumsummary", "fahuomoneysummary"]

          var startDate = new Date(this.searchdatevalue[0]);
          startDate = startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + "-" + startDate.getDate();
          var endDate = new Date(this.searchdatevalue[1]);
          endDate = endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + "-" + endDate.getDate();
          name = startDate + '~' + endDate + ' 全优学销售情况';
          name += ' 全优学销售情况';
          this.$exportExcel(header1, column1, data, name)
        } else {
          listdeptpre({
            deptname: this.searchdata,
            tenantid: this.searchtenant,
            managetenantid: this.managetenantid,
            province:this.form.province,city:this.form.city,county:this.form.county,
            validitydate:this.form.validitydate?"1":"",
            casestatus:this.casestatus
          }).then(response => {
            data = response.data.obj.rows
            for (let i in data) {
              data[i].tenantname = this.getTenantName(data[i]);
              data[i]["statusname"] = data[i].casestatus == 0 ? '待授权' : (data[i].casestatus == 1 ? '洽谈中' : '已签约');
            }
            header1 = ["服务商", "名称", "省", "市", "县", "提交人", "提交日期", "备注", "授权日期", "保证金", "有效期", "签约日期", "状态"]
            column1 = ["tenantname", "deptname", "province", "city", "county", "uname", "adddate", "descri", "auditdate", "bond", "validitydate", "contractdate", "statusname"]
            name = '全优学客户';
            this.$exportExcel(header1, column1, data, name);

          }).catch((error) => {
          })

        }
      },
      distributorHandleView(row){
        this.$refs.DataContactEditOther.show(['1'])
        this.$refs.DataContactEditOther.initData(row.customerguid, true);
      },
      AfterDeptCreate(deptrow,unitguid) {
        if(this.editrow.casestatus==9) {
          updatehospital({unitguid: this.editrow.unitguid, casestatus: 10, customerguid: unitguid}).then(response => {
            this.bindGrid();
          });
        }
      },
      //跳转编辑页面
      handleEdit(index, row, event) {
        this.$refs.hospitalAdd1.showEdit(row);
      },
      handleDelete(index, row) {
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          removehospital({unitguid: row.unitguid}).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              //刷新列表
              this.bindGrid();
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
            }
          })
        }).catch(() => {
        });
      },
      AfterSave(formdate, yeUnitGuid) {//保存后执行方法
        pass({
          unitguid: this.EditData.unitguid,
          uguid: this.EditData.uguid,
          yecontent: JSON.stringify(formdate),
          yeunitguid: yeUnitGuid
        }).then(response => {
          this.bindGrid();
        });
      },
      handleSelect(key){
        this.activeIndex=key;
        this.bindGrid();
      },
      //绑定分页参数
      bindGrid() {
        if (this.activeIndex == '1') {
          this.getWaitaudit();
        } else {
          this.salessub();
        }
      },
      getWaitaudit() {
        listdeptpre({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          deptname: this.searchdata,
          tenantid: this.searchtenant,
          managetenantid: this.managetenantid,
          province: this.form.province, city: this.form.city, county: this.form.county,
          validitydate: this.form.validitydate ? "1" : "",
          casestatus: this.casestatus
        }).then(response => {
          this.tableAudit = response.data.obj.rows;
          for (let i in this.tableAudit) {
            this.tableAudit[i].hasvalue=true;
            this.tableAudit[i].tenantname = this.getTenantName(this.tableAudit[i]);
          }
          this.pagination.total = response.data.obj.total
        }).catch((error) => {
          console.log(error)
        })
      },
      getTenantName(rows){
        switch (rows.tenantid){
          case 'e5682784-dbb7-4eba-939f-4c265092db1d':
            return '南京起舵（广州分公司）';
            break;
          case 'd6d0f500-6c34-45e6-b206-b87c368e4469':
            return '南京起舵电子商务有限公司';
            break;
          case '79b768f5-f02b-4eb4-a5a3-330cbf41f377':
            return '南京起舵（东北分公司）';
            break;
          default:
            return rows.tenantname;
        }
      },
      salessub() {
        if (this.searchdatevalue == null || this.searchdatevalue == '') {
          this.$message({
            message: '统计日期范围必须选择！',
            type: 'error'
          })
          return;
        }
        var startDate = new Date(this.searchdatevalue[0]);
        startDate= startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + "-" + startDate.getDate();
        var endDate = new Date(this.searchdatevalue[1]);
        endDate=endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + "-" + endDate.getDate()+' 23:59:59';
        listdeptpre({
          deptname: this.searchdata,
          tenantid: this.searchtenant,
          managetenantid: this.managetenantid,
          province:this.form.province,city:this.form.city,county:this.form.county,
          casestatus:10
        }).then(response => {
          this.tableAudit=[];
          for(let i in response.data.obj.rows){
            var row=response.data.obj.rows[i];
            row.hasvalue=false;
            row.fahuomoneysummary=0;
            row.fahuonumsummary=0;
            row.fahuopricesummary=0;
            row.ordernumsummary=0;
            row.ordermoneysummary=0;
            row.orderpricesummary=0;
            row.tenantname=this.getTenantName(row);
            this.tableAudit.push(row);
          }
          subhospital({datetype:'20',begindate:startDate,enddate:endDate}).then(fahuo=> {
            var fahuodata=fahuo.data.obj;
            for (let i in this.tableAudit) {
              var row = this.tableAudit[i];
              var item = fahuodata.find(o => o.customerserial == row.customerserial && o.tenantid == row.tenantid);
              if (item != null) {
                row.hasvalue=true;
                row['fahuonumsummary'] = item.totalnumber;
                row['fahuomoneysummary'] = item.salemoney;
                try{
                row['fahuopricesummary'] = (parseFloat(item.salemoney) / parseFloat(item.totalnumber)).toFixed(2);
                }catch(ex){

                }
              }
            }
          });
          subhospital({datetype:'10',begindate:startDate,enddate:endDate}).then(createorder=>{
            var fahuodata=createorder.data.obj;
            for (let i in this.tableAudit) {
              var row = this.tableAudit[i];
              var item = fahuodata.find(o => o.customerserial ==row.customerserial && o.tenantid == row.tenantid);
              if (item != null) {
                row.hasvalue=true;
                row['ordernumsummary'] = item.totalnumber;
                row['ordermoneysummary'] = item.salemoney;
                try{
                  row['orderpricesummary'] = (parseFloat(item.salemoney) / parseFloat(item.totalnumber)).toFixed(2);
                }catch(ex){

                }
              }
            }
            this.sorttable();
          });
        }).catch((error) => {
          console.log(error)
        })
      },
      sorttable() {
        var sort = 'ordermoneysummary';
        var order = 'desc';
        this.tableAudit.sort(function (a, b) {
          var begin = a[sort];
          var end = b[sort];
          if (order == 'desc') {
            begin = b[sort];
            end = a[sort];
          }

          if (begin==0 || end==0) {
            if (begin == 0 && end == 0) return 0;
            if (order == 'desc') {
              if (end == 0) return 1;
              else return -1;
            } else {
              if (end == 0) return -1;
              else return 1;
            }
          } else {
            if (begin > end) return 1;
            else if (begin == end) return 0;
            else return -1;
          }
        });
      },
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '';
            return;
          }
          if (index === 1) {
            sums[index] = '合计';
            return;
          }
          if (!column.property || column.property.indexOf('summary') == -1)
            return;

          var propertyArr = column.property.split('.');
          const values = propertyArr.length > 1 ? data.map(item => item[propertyArr[0]]).map(function (item) {
              if (item != null)
                return item[propertyArr[1]];
              else
                return 0;
            })
            : data.map(item => item[propertyArr[0]]);
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (sums[index]) {
            sums[index] = this.$numeric(sums[index], 2);
          }
          else
            sums[index] = ""
        });
        this.temp = sums
        return sums;
      },
    },
    mounted() {
      var model = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
      this.mytenantid = model.tenantid;
      this.independentserial = model.independentserial;
      this.managetenantid = '11cc17f4-2978-4be1-9169-4fe4a6580086';
      this.ismanage = this.mytenantid == this.managetenantid;//全优学服务商平台
      var end = new Date();//当天
      var start = new Date(end.getFullYear(), end.getMonth(), 1);
      this.searchdatevalue = [start, end];
      this.oldsearchdatevalue = this.searchdatevalue;
      this.pickerOptions2.shortcuts = pickerShortCuts();

      this.bindGrid();

      listhospital({managetenantid: this.managetenantid}).then(response => {
        this.tenantList = response.data.obj;
        for(let i in this.tenantList){
          this.tenantList[i].tenantname=this.getTenantName(this.tenantList[i]);
        }
      }).catch((error) => {
        console.log(error)
      });
    },
    components: {
      ExternaldeptEdit,
      hospitalAdd
    }
  }
</script>

<style>
  .el-table .warning-row {
    background: #C0C4CC !important;
  }

  .el-table .warning-row td {
    background: #C0C4CC !important;
    font-weight: bolder;
  }
</style>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/workflow/hospital/auditList.vue